export function factorTimeZone(dd: any, tz: string = null): any {
    const tzmins = tz ? getTZOffsetMinutes(tz) : (new Date()).getTimezoneOffset()
    if (typeof dd == 'number') {
        return dd - 1000 * 60 * tzmins;
    } else {
        for (let j = 0; j < dd.length; j++) {
            dd[j][0] -= 1000 * 60 * tzmins;
        }
    }
}

export function unfactorTimeZone(dd: number | number[][], tz: string = null): number {
    const tzmins = tz ? getTZOffsetMinutes(tz) : (new Date()).getTimezoneOffset()    

    if (typeof dd == 'number') {
        return dd + 1000 * 60 * tzmins;
    } else {
        for (let j = 0; j < dd.length; j++) {
            dd[j][0] += 1000 * 60 * tzmins;
        }
    }
}

export function getTZOffsetMinutes(tz:string) {
    const now = new Date();

  // 1. Get the local time in the target timezone
  const targetDateStr = now.toLocaleString('en-US', { timeZone: tz });
  const targetDate = new Date(targetDateStr);

  // 2. Get the local time in UTC
  const utcDateStr = now.toLocaleString('en-US', { timeZone: 'UTC' });
  const utcDate = new Date(utcDateStr);

  // 3. The difference in MS, converted to minutes
  // We use Math.round to account for any slight millisecond drift during execution
  const diffMinutes = Math.round((utcDate.getTime() - targetDate.getTime()) / 60000);

  return diffMinutes;
}

export function factorNYTimeZone(dd: any): any {
    return factorTimeZone(dd, 'America/New_York')
}

export function unfactorNYTimeZone(dd: number | number[][]): number {
    return unfactorTimeZone(dd, 'America/New_York')
}

export function factorServerTimeZone(dd: any): any {
    return factorTimeZone(dd, 'America/Los_Angeles')
}

export function unfactorServerTimeZone(dd: any): any {
    return unfactorTimeZone(dd, 'America/Los_Angeles')
}
